import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import styled from "styled-components";

import { ColorV2, ProgressBar, Text } from "@adoptaunabuelo/react-components";
import RightSectionContainer from "../../../components/container/RightSectionContainer";
import media from "styled-media-query";
import { ProductScheme } from "client-v2";

const Container = styled(RightSectionContainer)`
	margin-left: 42px;
	-ms-overflow-style: none;
	scrollbar-width: none;
	::-webkit-scrollbar {
		display: none;
	}
	${media.lessThan("small")`
		margin: 0px -24px;
        padding: 0px 24px;
        width: unset;
        background-color: ${ColorV2.surface.background};
	`}
`;
const ProgressBarView = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 32px;
`;
const CarrouselContainer = styled.div`
	display: flex;
	flex-direction: row;
	overflow-x: scroll;
	gap: 12px;
	margin-top: 16px;
	${media.lessThan("small")`
		margin: 32px -24px;
        padding: 0px 24px;
	`}
`;
const CarrouselCell = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-width: calc(100% - 8px - 32px);
	border-radius: 16px;
	padding: 4px;
	background-color: white;
	height: fit-content;
`;
const CarrouselImg = styled.img`
	width: 100%;
	height: 205px;
	object-fit: cover;
	border-radius: 16px;
`;
const CarrouselData = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px;
	gap: 8px;
`;
const ReliefContainer = styled.div`
	display: flex;
	flex-direction: row;
	background-color: white;
	border-radius: 16px;
	margin: 16px 0px 32px;
`;
const ReliefCell = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	padding: 12px 16px;
	align-items: center;
	gap: 8px;
	border-radius: 16px;
`;
const ReliefCellData = styled.div`
	display: flex;
	flex-direction: column;
`;
const ReliefCellIcon = styled.img`
	height: 64px;
	width: 64px;
`;

const PriceRight = (props: Props) => {
	const config = useSelector((state: State) => state.location.config);
	const appLocation = useSelector((state: State) => state.location.location);
	const [nActiveSubs, setNActiveSubs] = useState(0);

	const activities = [
		{
			title: "Cumplimos sus sueños",
			subtitle:
				"Creemos que nunca es tarde para hacerlos realidad. Por eso, cumplimos sueños como el de Ramón, que quería volver a jugar al béisbol. Gracias a vuestra colaboración, Ramón pudo disfrutar de un día increíble que nunca olvidará.",
			img: require("../../../assets/images/history/ramon.webp"),
			video: "https://youtube.com/shorts/n72-NPDbAeY",
		},
		{
			title: "Les acompañamos todas las semanas",
			subtitle:
				"A través de nuestro programa original de voluntariado, acompañamos a personas mayores que lo necesitan. Y siempre resulta una experiencia enriquecedora tanto para abuelos como para voluntarios.",
			img: require("../../../assets/images/history/raquel.webp"),
			video: "https://youtube.com/shorts/4jzq8rOR8l0",
		},
		{
			title: "Preparamos actividades en sus residencias",
			subtitle:
				"Realizamos actividades en residencias, como Flower Power. Una actividad donde mayores y voluntarios hacen un centro de flores mientras comparten su tiempo y sus historias.",
			img: require("../../../assets/images/history/valentina.webp"),
			video: "https://www.youtube.com/shorts/9fkKyzQHdOc",
		},
		{
			title: "Celebramos sus cumpleaños",
			subtitle:
				"Con vuestro apoyo, organizamos fiestas de cumpleaños a las personas mayores, haciendo que su día sea inolvidable. Tarta, regalos y mucha compañía para una celebración pensada para ella.",
			img: require("../../../assets/images/history/loli.webp"),
			video: "https://www.youtube.com/watch?v=D--PsMjx6Ys",
		},
		{
			title: "Los mayores no pagan nada por participar",
			subtitle:
				"Todos nuestros programas son completamente gratuitos para las personas mayores. Gracias a las donaciones, pueden disfrutar de acompañamiento y actividades sin ningún coste.",
			img: require("../../../assets/images/history/felisa.webp"),
			video: "https://www.youtube.com/watch?v=9BoL3KmF97M&list=PL2bO3y1ZkJ312Ovt0hS_v3G6oZsPwQkkA",
		},
	];

	useEffect(() => {
		getActiveSubscriptions();
	}, []);

	const getActiveSubscriptions = async () => {
		if (
			config &&
			config.attributes &&
			config.attributes.N_ACTIVE_SUBSCRIPTIONS
		) {
			setNActiveSubs(config.attributes.N_ACTIVE_SUBSCRIPTIONS.amount);
		}
	};

	return (
		<Container>
			<Text type="h4" weight="semibold">
				Somos una Fundación independiente y no recibimos subvenciones
			</Text>
			<Text type="p2" style={{ marginTop: 16 }}>
				Nuestra actividad se sostiene gracias al apoyo de personas
				comprometidas con las personas mayores. Te animamos a que formes
				parte de la Fundación como embajador.
			</Text>
			<ProgressBarView>
				<Text
					type="p2"
					weight="medium"
					style={{ color: ColorV2.text.primary }}
				>
					Ya somos {nActiveSubs} embajadores
				</Text>
				{nActiveSubs > 0 && (
					<ProgressBar
						progress={[
							{
								value: nActiveSubs,
							},
						]}
						maxValue={7500}
						style={{ marginBottom: 8 }}
					/>
				)}
				<Text type="p2" style={{ textAlign: "right" }}>
					Necesitamos llegar a los 7.500
				</Text>
			</ProgressBarView>
			<Text
				type="h5"
				weight="semibold"
				style={{
					paddingTop: 32,
					marginTop: 32,
					marginBottom: 16,
					borderTop: "1px solid " + ColorV2.border.neutralSoft,
				}}
			>
				El{" "}
				<span style={{ fontWeight: 600, color: ColorV2.text.primary }}>
					90% de tu donación
				</span>{" "}
				va destinada a las actividades con personas mayores
			</Text>
			<Text type="p">
				El 10% restante son costes operacionales (8%) y comisiones
				bancarias (2%).
			</Text>
			<Text type="p2" style={{ marginTop: 32 }}>
				Estas son algunas de las iniciativas que hacemos gracias a tu
				donación:
			</Text>
			<CarrouselContainer>
				{activities.map((activity, index) => (
					<CarrouselCell key={"activity-cell-" + index}>
						<CarrouselImg src={activity.img} />
						<CarrouselData>
							<Text type="h5" weight="semibold">
								{activity.title}
							</Text>
							<Text type="p2">{activity.subtitle}</Text>
						</CarrouselData>
					</CarrouselCell>
				))}
			</CarrouselContainer>
			{appLocation &&
				appLocation.country_code === "ES" &&
				appLocation.currency.name === "eur" && (
					<>
						<Text
							type="h5"
							weight="semibold"
							style={{
								paddingTop: 32,
								marginTop: 32,
								marginBottom: 16,
								borderTop:
									"1px solid " + ColorV2.border.neutralSoft,
							}}
						>
							Recupera hasta el 80% de lo que dones
						</Text>
						<Text type="p" style={{ marginBottom: 16 }}>
							Puedes deducirte tu donación en la Declaración de la
							Renta. De los primeros 250 € que dones te
							desgravarás el 80% y del resto el 40%*.
						</Text>
						<Text
							type="c1"
							style={{ color: ColorV2.text.neutralMedium }}
						>
							Además, si colaboras con nosotros con una donación
							igual o superior durante al menos 3 años, la
							desgravación se incrementa hasta el 45%.
						</Text>
						<Text
							type="p"
							weight="medium"
							style={{ marginTop: 32 }}
						>
							Te ponemos un ejemplo
						</Text>
						<ReliefContainer>
							<ReliefCell>
								<ReliefCellIcon
									src={require("../../../assets/images/icon/donation.webp")}
								/>
								<ReliefCellData>
									<Text type="p2" weight="medium">
										Si donas
									</Text>
									<Text type="h3" weight="semibold">
										15 €
									</Text>
								</ReliefCellData>
							</ReliefCell>
							<ReliefCell
								style={{
									backgroundColor: ColorV2.surface.secondary,
								}}
							>
								<ReliefCellIcon
									src={require("../../../assets/images/icon/coins.webp")}
								/>
								<ReliefCellData>
									<Text type="c1" weight="medium">
										Te devuelven
									</Text>
									<Text type="h3" weight="semibold">
										12 €
									</Text>
								</ReliefCellData>
							</ReliefCell>
						</ReliefContainer>
						<Text
							type="c2"
							style={{ color: ColorV2.text.neutralMedium }}
						>
							*El límite de la deducción sobre la base liquidable
							se mantiene en el 10%. Para el País Vasco y Navarra
							consultar regímenes tributarios especiales.
						</Text>
					</>
				)}
			<Text
				type="h5"
				style={{
					paddingTop: 32,
					marginTop: 32,
					marginBottom: 16,
					borderTop: "1px solid " + ColorV2.border.neutralSoft,
				}}
			>
				Hemos acompañado a miles de personas mayores,{" "}
				<span style={{ fontWeight: 600 }}>
					pero todavía nos quedan millones por acompañar.
				</span>
			</Text>
		</Container>
	);
};
export default PriceRight;
export interface Props {
	product?: ProductScheme;
}
